(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./index.less", "../_util/barrier-free", "../_mixins/osProps"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./index.less"), require("../_util/barrier-free"), require("../_mixins/osProps"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.index, global.barrierFree, global.osProps);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _index, _barrierFree, _osProps) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _osProps = _interopRequireDefault(_osProps);
  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        staticClass: "nx-dropdown-menu",
        class: [_vm.isDarkCover ? 'nx-dropdown-menu-darkcover' : '', {
          'nx-os-blur-material': _vm.blurMaterial
        }],
        style: _vm.initScaleStyle
      }, [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.showPop,
          expression: "showPop"
        }],
        staticClass: "nx-dropdown-menu-mask",
        on: {
          "click": function click($event) {
            $event.stopPropagation();
            _vm.showPop = false;
          }
        }
      }), _c('div', {
        ref: "nx-dropdown-menu-content",
        staticClass: "nx-dropdown-menu-content",
        class: {
          'is-normal': _vm.type == 'normal'
        },
        style: _vm.widthStyle
      }, [_vm.type == 'dropdown' ? _c('div', [_c('div', {
        staticClass: "nx-dropdown-menu-content-value",
        class: {
          'nx-dropdown-menu-content-value-grey': !_vm.selectItem && !_vm.defaultText
        },
        attrs: {
          "role": "button",
          "aria-label": _vm.broadcast(_vm.selectItem || _vm.placeholder),
          "tabindex": "0"
        },
        on: {
          "click": _vm.toggle
        }
      }, [_vm._v("\n        " + _vm._s(_vm.selectItem ? _vm.selectItem : _vm.defaultText ? _vm.defaultText : _vm.placeholder) + "\n      ")]), _c('div', {
        ref: "nx-dropdown-menu-content-arrow",
        staticClass: "nx-dropdown-menu-content-arrow",
        on: {
          "click": _vm.toggle
        }
      })]) : _vm._e(), _vm.type == 'normal' ? _c('div', [_c('div', {
        ref: "nx-dropdown-menu-content-value",
        staticClass: "nx-dropdown-menu-content-value",
        class: {
          'is-normal': _vm.type == 'normal',
          'is-showpop': _vm.showPop
        },
        attrs: {
          "role": "button",
          "aria-label": _vm.broadcast(_vm.selectItem || _vm.placeholder),
          "tabindex": "0"
        },
        on: {
          "click": _vm.toggle
        }
      }, [_vm._t("menuIcon"), !_vm.$slots.menuIcon ? _c('img', {
        staticClass: "icon",
        attrs: {
          "src": _vm.iconUrl,
          "alt": ""
        }
      }) : _vm._e()], 2)]) : _vm._e(), _c('div', {
        attrs: {
          "role": "alertdialog"
        }
      }, [_c('div', {
        ref: "nx-dropdown-menu-content-list",
        staticClass: "nx-dropdown-menu-content-list",
        class: [_vm.needTopShow ? 'nx-dropdown-menu-content-list-top' : 'nx-dropdown-menu-content-list-bottom', _vm.popPosition == 'right' || _vm.isRight ? 'is-right' : ''],
        attrs: {
          "role": "listbox"
        }
      }, [_vm._t("default"), _vm._l(_vm.list, function (item, index) {
        return _c('div', {
          key: index,
          staticClass: "nx-dropdown-menu-content-list-item",
          class: {
            'is-active': typeof _vm.selectIndex == 'number' ? _vm.selectIndex == index : item.value == _vm.value,
            'is-disabled': item.disabled
          },
          attrs: {
            "role": "option",
            "aria-label": _vm.broadcast(item.text || item.selectedText),
            "tabindex": index
          },
          on: {
            "click": function click($event) {
              return _vm.select(item);
            }
          }
        }, [_c('span', {
          staticClass: "nx-dropdown-menu-content-list-item-text"
        }, [_vm._v(_vm._s(item.text || item.selectedText))])]);
      })], 2)])])]);
    },
    name: 'nx-dropdown-menu',
    components: {},
    props: {
      show: {
        type: Boolean,
        default: false
      },
      popPosition: {
        type: String,
        default: 'left' // left、right、auto

      },
      value: null,
      iconUrl: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: 'dropdown' // dropdown、normal

      },
      defaultText: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: '请选择'
      },
      width: {
        type: [String, Number],
        default: 'auto'
      },
      isDarkCover: {
        type: Boolean,
        default: false
      },
      list: Array,
      selectIndex: {
        type: [Number, undefined],
        default: undefined
      },
      listScale: {
        type: [Number, String],
        default: '1'
      }
    },
    mixins: [_osProps.default],
    data: function data() {
      return {
        showPop: false,
        eachH: '',
        needTopShow: false,
        isRight: false
      };
    },
    computed: {
      selectItem: {
        get: function get() {
          var _this = this;

          var selectedItem = this.list.length && this.list.filter(function (item) {
            return item.value == _this.value;
          })[0];
          return this.value ? selectedItem.selectedText || selectedItem.text : '';
        },
        set: function set() {}
      },
      widthStyle: function widthStyle() {
        var style = {};

        if (this.width != 'auto') {
          style.width = this.width / 100 + 'rem';
        }

        return style;
      },
      menuScale: function menuScale() {
        return this.type == 'normal' ? this.listScale : 1;
      },
      initScaleStyle: function initScaleStyle() {
        // 0.3 1 1.02
        return {
          '--menu-scale': this.menuScale,
          '--menu-scale-small': this.menuScale * 0.3,
          '--menu-scale-big': this.menuScale * 1.02
        };
      }
    },
    watch: {
      show: function show(val) {
        this.showPop = val;
      },
      showPop: function showPop(val) {
        var _this2 = this;

        this.getUnitWitdh();
        this.computeShow();
        var contentEl = this.$refs['nx-dropdown-menu-content'];
        var listEl = this.$refs['nx-dropdown-menu-content-list'];
        this.$nextTick(function () {
          _this2.isRight = _this2.popPosition == 'auto' && _this2.computeIsRight(); // 普通菜单

          if (_this2.type == 'normal') {
            var valEl = _this2.$refs['nx-dropdown-menu-content-value'];
            listEl.style.transformOrigin = "".concat(_this2.popPosition == 'right' || _this2.isRight ? listEl.clientWidth / _this2.eachH : 0, "rem ").concat(_this2.needTopShow ? '100%' : '0');
            valEl.style.transition = 'opacity 200ms cubic-bezier(0.33, 0.00, 0.67, 1)';
          } // 下拉菜单


          if (_this2.type == 'dropdown') {
            _this2.dropdownAnimate(val, contentEl, listEl);
          }

          if (val) {
            listEl.style.transform = "scale(".concat(_this2.menuScale, ")");
            listEl.style.opacity = '1';
            listEl.style.animation = 'menuPopShow 400ms, menuPopShowOpacity 200ms';
          } else {
            listEl.style.transform = 'scale(0)';
            listEl.style.opacity = '0';
            listEl.style.animation = 'menuPopHide 300ms, menuPopHideOpacity 300ms';
          }

          _this2.$emit('update:show', val);
        });
      },
      menuScale: function menuScale() {
        var listEl = this.$refs['nx-dropdown-menu-content-list'];
        listEl.style.transform = "scale(".concat(this.menuScale, ")");
      }
    },
    created: function created() {},
    mounted: function mounted() {
      // this.getUnitWitdh()
      if (this.show) {
        this.showPop = true;
      } // window.addEventListener('resize', this.getUnitWitdh)

    },
    methods: {
      dropdownAnimate: function dropdownAnimate(val, contentEl, listEl) {
        var arrow = this.$refs['nx-dropdown-menu-content-arrow'];

        if (this.width == 'auto') {
          var el = this.popPosition == 'right' || this.isRight ? listEl : contentEl;
          var originLeft = "".concat((el.clientWidth - 0.27 * this.eachH) / listEl.clientWidth * 100, "%");
          listEl.style.transformOrigin = "".concat(originLeft, " ").concat(this.needTopShow ? '100%' : '0');
        } else {
          var _originLeft = this.popPosition == 'right' || this.isRight ? "".concat((listEl.clientWidth - 0.27 * this.eachH) / listEl.clientWidth * 100, "%") : "".concat((this.width / 3 - 27) / this.width * 100, "%");

          listEl.style.transformOrigin = "".concat(_originLeft, " ").concat(this.needTopShow ? '100%' : '0');
        }

        if (val) {
          arrow.style.transform = 'rotate(360deg)';
          arrow.style.animation = 'menuPopArrowUp 350ms';
        } else {
          arrow.style.transform = 'rotate(180deg)';
          arrow.style.animation = 'menuPopArrowDown 350ms';
        }
      },
      getUnitWitdh: function getUnitWitdh() {
        var h = document.getElementsByTagName('head')[0];
        var el = h && h.querySelector('#nx-each-h-flag');
        var d = document.createElement('div');
        el && h.removeChild(el);
        d.id = 'nx-each-h-flag';
        d.style.width = '1rem';
        d.style.display = 'none';
        h.appendChild(d);
        this.eachH = parseFloat(getComputedStyle(d, null).getPropertyValue('width'));
      },
      computeIsRight: function computeIsRight() {
        var contentEl = this.$refs['nx-dropdown-menu-content'];
        var pageW = document.documentElement.clientWidth; // 距离左侧距离

        var distLeft = contentEl.getBoundingClientRect().left; // 距离右侧距离

        var distRight = pageW - contentEl.getBoundingClientRect().right; // console.log(distLeft > distRight)

        return distLeft > distRight;
      },
      computeShow: function computeShow() {
        var contentEl = this.$refs['nx-dropdown-menu-content'];
        var h = (this.list.length * 1.44 + 0.51 * 2) * this.eachH;
        var maxH = 9.9 * this.eachH; // 弹窗高度

        var listH = h > maxH ? maxH : h;
        var pageH = document.documentElement.clientHeight; // 距离底部高度

        var distBottom = pageH - contentEl.getBoundingClientRect().bottom; // 距离顶部高度

        var distTop = contentEl.getBoundingClientRect().top; // 下拉框是否需要往上展示

        this.needTopShow = distBottom && listH && distBottom && distBottom < listH && distTop > listH;
      },
      broadcast: function broadcast(string) {
        (0, _barrierFree.formatNumAndLetter)(string);
      },
      select: function select(item) {
        var _this3 = this;

        if (item.disabled) {
          return;
        }

        this.showPop = !this.showPop;
        this.$emit('input', item.value);
        this.$emit('change', item.value, item);
        this.$nextTick(function () {
          _this3.selectItem = item.selectedText || item.text;
        });
      },
      toggle: function toggle() {
        if (!this.list.length) {
          return;
        }

        this.showPop = !this.showPop;
      }
    } // beforeDestroy() {
    //   window.removeEventListener('resize', this.getUnitWitdh)
    // },

  };
  _exports.default = _default;
});